<template>
  <div class="d-flex justify-content-end min-vh-100 pb-5">
    <QuestionnaireSideBar
      :questionnaireOptions="list"
      :listId="listId"
      :finishCount="finishCount"
    />
    <div
      class="header flex-column align-items-start"
      style="background: white; z-index: 3"
    >
      <div class="d-flex justify-content-between w-100">
        <h1>{{ title }}</h1>
        <CButton
          v-if="isDelete === '0'"
          type="submit"
          class="text-white"
          color="primary"
          @click="editQue()"
          >儲存</CButton
        >
        <CButton v-else type="submit" class="text-white" color="secondary"
          >問卷已刪除</CButton
        >
      </div>
      <div class="d-flex justify-content-between align-items-center part-info">
        <h2>{{ partTitle }}</h2>
        <div
          v-if="partTitle"
          class="filter-items-wrapper d-flex justify-content-center align-items-center"
        >
          <div
            class="filter-items"
            :class="{ 'filter-items-active': filterItem === 'all' }"
            @click="changeFilterItem('all')"
          >
            全部
          </div>
          <div
            class="filter-items"
            :class="{ 'filter-items-active': filterItem === 'done' }"
            @click="changeFilterItem('done')"
          >
            已填寫
          </div>
          <div
            class="filter-items"
            :class="{ 'filter-items-active': filterItem === 'undone' }"
            @click="changeFilterItem('undone')"
          >
            未填寫
          </div>
          <div
            class="filter-items"
            :class="{ 'filter-items-active': filterItem === 'unknow' }"
            @click="changeFilterItem('unknow')"
          >
            需要專人協助
          </div>
        </div>
      </div>
    </div>

    <div class="body">
      <CContainer fluid class="que-body">
        <!-- <pre>{{ queList }}</pre> -->
        <div
          v-for="(item, index) in queList"
          :key="item"
          class="col-10 py-4 mx-auto"
          v-show="
            filterList.find((e) => e === item.part_item_id) &&
            item.type !== $defines.ItemTypes.Introduction
          "
        >
          <div
            class="d-flex justify-content-between align-items-center"
            style="white-space: normal"
          >
            <div class="topic mt-3 d-flex col-12">
              {{ item.itemIndex }}.
              <div class="mx-2 item-title">
                {{ item.title }}
<!--                <span style="color: #e40017; padding-left: 5px">*</span>-->
              </div>
              <CBadge
                color="primary"
                v-if="item.type === 'ChoiceOne'"
                class="ms-2"
                style="height: 30px"
                >單選</CBadge
              >
              <CBadge
                color="primary"
                v-if="item.type === 'ChoiceMultiple'"
                class="ms-2"
                style="height: 30px"
                >複選</CBadge
              >
            </div>
            <!-- <button
              v-if="+isConfirm !== 1"
              :class="{ 'sure-active': +item.is_help }"
              @click="setIsHelp(item.part_item_id)"
              class="not-sure-active col-2"
            > {{ item.is_help === '1' ? '取消專人協助' : '需要專人協助' }}
            </button> -->
          </div>
          <p
            v-if="item.description"
            class="remark ms-4"
            style="
              border-top: 1px solid rgba(0, 0, 0, 0.1);
              padding-top: 10px;
              white-space: normal;
            "
          >
            {{ item.description }}
          </p>
          <div
            style="cursor: pointer"
            class="preview-img"
            v-if="item.image"
            @click="enlargeImg = !enlargeImg"
          >
            <CImage
              class="mb-4"
              rounded
              thumbnail
              width="200"
              height="200"
              style="cursor: pointer"
              :src="item.image"
            />
            <img class="enlarge" src="@/assets/icons/enlarge.svg" alt="" />
            <EnLargeImg :show="enlargeImg" :image="item.image" />
          </div>
          <component
            :is="
              item.type === 'ColumnInput' || item.type === 'Scale'
                ? null
                : $defines.ItemTypesMap[item.type]
            "
            :info="item"
            @content="questionnaireAnswer"
          />
          <Nest
            v-if="item.type === 'Scale'"
            :info="item"
            :value="item.value"
            :order="index"
            :options="item.options"
            :type="item.type"
            :id="item.id"
            :title="item.title"
            :nest="item.nest"
            @content="questionnaireAnswer"
            :showChild="item.type === '3' ? x[item.id] : x[item.nest]"
            @isOpen="
              item.type === '3'
                ? (x[item.id] = $event)
                : (x[item.nest] = $event)
            "
          />
          <Form
            v-if="item.type === 'ColumnInput'"
            :info="item"
            :value="item.value"
            :order="index"
            :options="item.options"
            :type="item.type"
            :id="item.id"
            :title="item.title"
            :nest="item.nest"
            @content="questionnaireAnswer"
            :showChild="item.type === '13' ? x[item.id] : x[item.nest]"
            @isOpen="
              item.type === '13'
                ? (x[item.id] = $event)
                : (x[item.nest] = $event)
            "
          />
          <div
            v-if="
              filterList.find((e) => e === item.part_item_id) &&
              item.type !== $defines.ItemTypes.Introduction
            "
            class="py-2 flex flex-col"
          >
            <button
              v-if="+isConfirm !== 1"
              :class="{ 'sure-active': +item.is_help }"
              @click="setIsHelp(item.part_item_id)"
              class="not-sure-active w-150px m-0"
            > {{ item.is_help === '1' ? '取消專人協助' : '需要專人協助' }}
            </button> 
            <div
              v-if="item.is_help === '1'"
              class="mt-1"
            >
              <CFormTextarea
                v-model="item.help_message"
                placeholder="請填入文字"
                rows="3"
                @change="ChangeHelpText(item)"
              />
            </div>
          </div>
        </div>
      </CContainer>
    </div>
  </div>
  <MsgBox :show="showMsgBox" :errorMsg="errorMsg" @close="showMsgBox = false" />
</template>
<script>
import Input from '@/components/Answer/Input.vue'
import File from '@/components/Answer/File.vue'
import NumberInput from '@/components/Answer/NumberInput.vue'
import Radio from '@/components/Answer/Radio.vue'
import Nest from '@/components/Answer/Nest.vue'
import Form from '@/components/Answer/Form.vue'
import RangeBar from '@/components/Answer/RangeBar.vue'
import Textarea from '@/components/Answer/Textarea.vue'
import CheckBox from '@/components/Answer/CheckBox.vue'
import CategoryTitle from '@/components/Answer/CategoryTitle.vue'
import Divider from '@/components/Answer/Divider.vue'
import Star from '@/components/Answer/Star.vue'
import Date from '@/components/Answer/Date.vue'
import ItemSort from '@/components/Answer/ItemSort.vue'
import EnLargeImg from '@/components/Answer/EnLargeImg.vue'
import DynamicForm from '@/components/Answer/DynamicForm.vue'
import QuestionnaireSideBar from '@/components/Answer/QuestionnaireSideBar.vue'
import MsgBox from '@/components/MsgBox.vue'
import { ref } from '@vue/reactivity'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'
import useQuestionnaire from '@/composables/useQuestionnaire'
import { computed, onMounted } from '@vue/runtime-core'
import router from '@/router'
import MessageBox from '@/plugins/MessageBox'
import { ItemTypes } from '../defines'

export default {
  components: {
    QuestionnaireSideBar,
    Input,
    Radio,
    Nest,
    RangeBar,
    Textarea,
    CheckBox,
    NumberInput,
    File,
    CategoryTitle,
    DynamicForm,
    Star,
    Divider,
    ItemSort,
    Date,
    MsgBox,
    Form,
    EnLargeImg,
  },
  setup() {
    const {
      getQuestionnaire,
      editFillIn,
      getFillInInfo,
      questionnairePartInfo,
    } = useQuestionnaire()
    const title = ref('')
    const isConfirm = ref('0')
    const partTitle = ref('')
    const route = useRoute()
    const list = ref([])
    const listId = ref(route.params.id)
    const errorCode = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const answerList = ref([])
    const questionnaireId = ref('')
    const queList = ref([])
    const answer = ref([])
    const isDelete = ref('0')
    const enlargeImg = ref(false)
    const x = ref({})
    const originListStr = ref('[]')
    const filterItem = ref('all')
    const filterAnswer = ref([])
    const finishCount = ref([])
    const getNestAndFormId = () => {
      const nestAndFormId =
        list.value.reduce((accu, cur) => {
          if (cur.type === '3' || cur.type === '13') {
            accu[cur.id] = false
          }
          return accu
        }, {}) || {}
      x.value = nestAndFormId
    }
    const displayIndexMap = computed(() =>
      queList.value
        .filter((item) => item.type !== '4' && item.type !== '14')
        .reduce((accu, cur, i) => {
          accu[cur.id] = i + 1
          return accu
        }, {}),
    )

    const ChangeHelpText = (info) => {
      const updateObj = {
        part_item_id: info.part_item_id,
        type: info.type,
        is_help: +info.is_help ? '1' : '0',
        help_message: info?.help_message ||'',
        is_finish: false,
        value_info: '',
      }
      questionnaireAnswer(updateObj);
    };

    const setIsHelp = (id) => {
      const queIndex = queList.value.findIndex((e) => e.part_item_id === id)
      // const index = answerList.value.findIndex(e=> e.part_item_id === id)
      queList.value[queIndex].is_help = queList.value[queIndex].is_help === '1' ? '0' : '1'
      // answerList.value[index].is_help = answerList.value[index].is_help === '1' ? '0' : '1'
    }

    const hasEdited = computed(() => {
      const originList = JSON.parse(originListStr.value)
      const originListIndex = originList.findIndex(
        (item) => item.part_id == route.params.part,
      )

      const sortedOrigin = originList[originListIndex]?.part_items || []
      const sortedCurrent = JSON.parse(JSON.stringify(answerList.value)).map(
        (obj) => {
          return Object.fromEntries(Object.entries(obj).sort())
        },
      )
      // const sortedCurrent = JSON.parse(JSON.stringify(answerList.value)).map(
      //   (obj) => {
      //     return Object.fromEntries(Object.entries(obj).sort())
      //   },
      // )
      let sortedOriginMap = {}
      for (const item of sortedOrigin) {
        sortedOriginMap[item.part_item_id] = item
      }

      for (const sortedCurrentItem of sortedCurrent) {
        const originItem = sortedOriginMap[sortedCurrentItem.part_item_id]
        // if(originItem?.type=="DynamicForm") continue
        // if(originItem?.type=='ColumnInput') continue
        for (const sortedCurrentItemKey in sortedCurrentItem) {
          try {
            const originItemValue = JSON.stringify(
              originItem[sortedCurrentItemKey] || ''
            )
            const sortedCurrentValue = JSON.stringify(
              sortedCurrentItem[sortedCurrentItemKey] || ''
            )
            if (originItemValue != sortedCurrentValue) {
              if (
                sortedCurrentItemKey !== 'is_help' &&
                sortedCurrentItemKey !== 'is_finish'
              ) {
                return true
              }
            }
          } catch (e) {
            continue
          }
        }
      }
      return false
    })

    onBeforeRouteUpdate(async () => {
      const leave = async () => {
        await getFillInfo()
      }
      if (hasEdited.value) {
        let flag = null
        MessageBox({
          message: '此分類尚未儲存，請先儲存再進行動作避免資料遺失。',
          cancelButtonText: '不保存離開此頁',
          confirmButtonText: '繼續編輯',
          cancelBtnColor: 'secondary',
          confirmBtnColor: 'primary',
          onConfirm: () => {
            flag = true
          },
          onCancel: () => {
            flag = false
          },
        })
        let p = new Promise((resolve) => {
          const timer = setInterval(() => {
            if (flag !== null) {
              clearInterval(timer)
              resolve(flag)
            }
          }, 30)
        })
        const saveConfirm = await p
        if (saveConfirm) {
          flag = null
          return false
        } else {
          answerList.value = []
          leave()
          return true
        }
      } else {
        answerList.value = []
        leave()
      }
    })
    const questionnaireAnswer = async (e) => {
      const findId = answerList.value.findIndex(
        (item) => item.part_item_id === e.part_item_id,
      )
      if (findId === -1) {
        await answerList.value.push(e)
      } else {
        await answerList.value.splice(findId, 1, e)
      }
      await getFilterAnswerList()
    }
    const changeFilterItem = async (e) => {
      filterItem.value = e
      getFilterAnswerList()
    }
    const getFilterAnswerList = () => {
      if (filterItem.value === 'done') {
        filterAnswer.value = answerList.value.filter((e) => e.is_finish)
      } else if (filterItem.value === 'undone') {
        filterAnswer.value = answerList.value.filter((e) => !e.is_finish)
      } else if (filterItem.value === 'unknow') {
        filterAnswer.value = answerList.value.filter((e) => +e.is_help === 1)
      } else {
        filterAnswer.value = JSON.parse(JSON.stringify(answerList.value))
      }
    }
    const filterList = computed(() => {
      if (!answerList.value.length) return queList.value
      if (!queList.value.length) return []
      let newData = []
      for (let i = 0; i < queList.value.length; i++) {
        for (let v = 0; v < filterAnswer.value.length; v++) {
          if (
            filterAnswer.value[v].part_item_id === queList.value[i].part_item_id
          ) {
            newData.push(queList.value[i].part_item_id)
          }
        }
      }
      return newData
    })
    const getFillInfo = async () => {
      const res = await getFillInInfo({ id: listId.value })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        isConfirm.value = res.ret.info.is_confirm
        const _answer = res.ret.info.result_items
        answer.value = JSON.parse(JSON.stringify(_answer))
        originListStr.value = JSON.stringify(_answer)
        // answerList.value =
        //   answer.value.find((e) => {
        //     return e.part_id === +route.params.part
        //   })?.subjects_info_fill || []

        questionnaireId.value = res.ret.info.questionnaire_id
        finishCount.value = res.ret.info.finish_count
      
        await getQue()
        // answerList.value?.forEach((answer, i) => {
        //   queList.value[i].value = answer.value
        // })
      }
    }
    const getQue = async () => {
      const res = await getQuestionnaire({ id: questionnaireId.value })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        // isDelete.value = res.ret.info[0].is_delete
        title.value = res.ret.questionnaire.title
        list.value = res.ret.questionnaire.parts
        if (!route.params.part) {
          router.push(
            `/result/${listId.value}/${res.ret.questionnaire.parts[0].id}`,
          )
        }
        list.value.forEach(async (e) => {
          const partItems = await questionnairePartInfo({ id: e.id })
          e.items = partItems.ret.info.items || []
        })
        const itemList = await questionnairePartInfo({ id: route.params.part })
        if (itemList.error) {
          return
        }
        
        queList.value = itemList.ret.info.items.filter(item => item.is_display !== "0") || [];

        queList.value.reduce((accu, cur) => {
          if (cur.type !== ItemTypes.Introduction) {
            cur.itemIndex = accu
            return accu + 1
          } else {
            return accu
          }
        }, 1)

        const currentAnswer = answer.value.find(
          (e) => +e.part_id === +route.params.part,
        )
        let currentAnswerMap = {}
        if (currentAnswer?.part_items) {
          currentAnswer.part_items.forEach((e) => {
            currentAnswerMap[e.part_item_id] = e
          })
        }
        for (const item of queList.value) {
          item.value_info = currentAnswerMap[item.part_item_id]?.value_info || null
          item.is_finish = currentAnswerMap[item.part_item_id]?.is_finish
          item.is_help = currentAnswerMap[item.part_item_id]?.is_help
          // modify
          item['help_message'] = currentAnswerMap[item.part_item_id].help_message;
        }
 
        // Modify textarea error
        for (const itemInfo of queList.value) {
          for (const rowIndex in itemInfo.extension_info?.rows || []) {
            const rowItem = itemInfo.extension_info?.rows[rowIndex];
            for( const colIndex in itemInfo.extension_info?.cols || []) {
              rowItem[`answer${colIndex}`] = itemInfo.value_info?.[rowIndex]?.[colIndex]
            }
          }
        }
        // answerList.value = currentAnswer.pare_items
        partTitle.value = list.value?.find((e) => {
          return e.id === +route.params.part
        })?.title
      }
    }

    onMounted(async () => {
      // window.addEventListener('message', (e)=> {
      //   if(e){
      //     router.push(`/result/${listId.value}/${list.value[0].id}`)
      //   }
      // }, false);
      await getFillInfo()
      const id = route.params.part || list.value?.[0].part_id
      if (id) {
        router.push(`/result/${listId.value}/${id}`)
      }
    })
    const editQue = async () => {
      const fillInfo = await getFillInInfo({ id: listId.value })
      if (fillInfo.error) {
        showMsgBox.value = true
        errorMsg.value = fillInfo.msg
        errorCode.value = fillInfo.error
      } else {
        let answers = fillInfo.ret.info.result_items
        if (answers) {
          const item = answers.find((e) => +e.part_id === +route.params.part)
          if (item) {
            item.part_items = answerList.value
          } else {
            answers.push({
              part_id: +route.params.part,
              part_items: answerList.value,
            })
          }
        } else {
          answers = [
            {
              part_id: +route.params.part,
              part_items: answerList.value,
            },
          ]
        }
        const res = await editFillIn({
          id: listId.value,
          data: [...answers],
        })
        if (res.error) {
          showMsgBox.value = true
          errorMsg.value = res.msg
          errorCode.value = res.error
        } else {
          // originListStr.value = JSON.stringify(answerList.value)
          MessageBox({
            message: '修改成功',
            showCancelButton: false,
            onConfirm: () => {
              location.reload()
            },
            onCancel: () => {
              location.reload()
            },
          })
        }
      }
    }
    return {
      ChangeHelpText,
      list,
      listId,
      getFillInfo,
      errorCode,
      errorMsg,
      showMsgBox,
      getQue,
      title,
      answerList,
      answer,
      questionnaireId,
      queList,
      editQue,
      displayIndexMap,
      questionnaireAnswer,
      isDelete,
      partTitle,
      enlargeImg,
      getNestAndFormId,
      x,
      filterItem,
      filterList,
      changeFilterItem,
      filterAnswer,
      getFilterAnswerList,
      finishCount,
      setIsHelp,
      isConfirm,
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 30px 40px;
  width: calc(100vw - 255px);
  right: 0;
  position: fixed;
  top: 0;
  z-index: 1;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
h2 {
  max-width: 30vw;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #000000;
}

.body {
  width: calc(100vw - 255px);
  white-space: pre-line;
  overflow-x: scroll;
  white-space: nowrap;
  padding-top: 40px;
}
.topic {
  font-size: 16px;
}
.submit-button {
  margin-top: 88px;
  margin-bottom: 107px;
  max-width: 200px;
  width: 100%;
}
.que-body {
  margin-top: 150px;
  width: calc(100vw - 255px);
  overflow-x: scroll;
  white-space: nowrap;
}
.enlarge {
  display: none;
  width: 20px;
  position: absolute;
  right: 5px;
  bottom: 30px;
}
.preview-img {
  width: 200px;
  position: relative;
  &:hover {
    .enlarge {
      display: block;
    }
  }
}
.item-title {
  font-size: 20px;
  font-weight: 600;
  padding-bottom: 10px;
}
.part-info {
  width: 100%;
  margin-top: 20px;
}
.filter-items-wrapper {
  width: 400px;
  border-radius: 8px;
  overflow: hidden;
}
.filter-items {
  flex: 1;
  background-color: #177baf;
  border-right: 1px solid #fff;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  &:hover {
    background-color: #2a90c7;
  }
}
.filter-items-active {
  background-color: #96c6e0;
}

.not-sure {
  border: none;
  background-color: #177baf;
  border: 1px solid #177baf;
  color: #fff;
  border-radius: 5px;
  font-size: 13px;
  line-height: 30px;
  height: 30px;
  padding: 0 18px;
  margin-left: 10px;
  &:hover {
    background-color: #3c9dd1;
  }
}
.not-sure-active {
  background-color: #f9ba0d;
  border: 1px solid #f9ba0d;
  color: #fff;
  &:hover {
    background-color: #fdcb41;
  }
}
.sure-active {
  background-color: #fff;
  border: 1px solid #f9ba0d;
  color: #f9ba0d;
  &:hover {
    background-color: #ffefc3;
  }
}
</style>
